// IMPORT REACT
import React from "react";

// IMPORT CONTAINERS
import Layout from '../Layout';

// IMPORT COMPONENTS
import YAContainer from '../../components/Grid/Container';
import YASection from '../../components/Grid/Section';
import YARow from '../../components/Grid/Row';
import YAColumn from '../../components/Grid/Column';
import YAText from '../../components/Text';

// IMPORT STYLES
// import { Sc_Container  } from '../styles';

const NotFound = () => {
  const page = [];
  const bloginfo = null;
  const lang = 'en';
 
  return (
    <Layout lang={lang} page={page} bloginfo={bloginfo}
    	header={
    		<Header lang={lang} page={page} />
    	}
    	body={
    		<div>
    		  <SectionMiddle />
        </div>
    	}
      
    />
  );
}

const Header = ({ page }) => (
  <div>
    <YARow center>
      <YAColumn size="col-md-8 col-lg-6">
        <YAText tag="h1" bootstrap="display-4 mb-3">
          404 Not Found
        </YAText>
      </YAColumn>
    </YARow>
  </div>
);

const SectionMiddle = () => (
  <YASection>
    <YAContainer>
      <YARow center>
        <YAColumn size="col-lg-12">
          <YAText tag="h2">
            Sorry, this page doesn't exist.
          </YAText>
        </YAColumn>
      </YARow>
    </YAContainer>
  </YASection>
);

export default NotFound;